import { useState, useEffect } from "react";
import "./LoadCurtain.css";

function LoadCurtain({ delay = 600 }) {
  const [visible, setVisible] = useState(true);
  const [lifting, setLifting] = useState(false);

  useEffect(() => {
    let raf1, raf2;
    // Double RAF ensures the browser has fully painted the curtain before
    // adding the lifting class — required on iOS Safari / slow mobile renders
    const t = setTimeout(() => {
      raf1 = requestAnimationFrame(() => {
        raf2 = requestAnimationFrame(() => {
          setLifting(true);
        });
      });
    }, delay);
    // Remove from DOM after lift completes: delay + 1100ms transition + 100ms buffer
    const remove = setTimeout(() => setVisible(false), delay + 1200);
    return () => {
      clearTimeout(t);
      clearTimeout(remove);
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, [delay]);

  if (!visible) return null;

  return (
    <div
      className={`lc-curtain${lifting ? " lc-lifting" : ""}`}
      onTransitionEnd={() => { if (lifting) setVisible(false); }}
    >
      <div className="lc-logo-wrap">
        <img src="/image/exyst-space-logo.svg" alt="exyst space" className="lc-logo"
          onError={(e) => { e.target.style.display = "none"; }}
        />
        <div className="lc-dot-row">
          <span className="lc-dot" style={{ animationDelay: "0ms" }} />
          <span className="lc-dot" style={{ animationDelay: "200ms" }} />
          <span className="lc-dot" style={{ animationDelay: "400ms" }} />
        </div>
      </div>
    </div>
  );
}

export default LoadCurtain;
